import React, { useMemo } from 'react';
import type { PropsWithChildren } from 'react';

import { CustomSearchExtensionPropsContext } from '@atlassian/custom-search-extension';

import { PEOPLE_DIRECTORY, ADVANCED_SEARCH } from '@confluence/named-routes';
import { useRouteActions } from '@confluence/route-manager/entry-points/RouteState';
import { useSessionData } from '@confluence/session-data';

import { useGetSpaceIdsFromSpaceKeys } from '../../link-cards/LinkCardsConfigPanel/components/DynamicContentModalDialog/useGetSpaceIdsFromSpaceKeys';

export const CustomSearchExtensionPropsProvider = ({ children }: PropsWithChildren<{}>) => {
	const sessionData = useSessionData();
	const routeActions = useRouteActions();
	const getSpaceIdsFromSpaceKeys = useGetSpaceIdsFromSpaceKeys();

	const {
		cloudId = '',
		displayName = '',
		isAdminHubAIEnabled = false,
		orgId = '',
		userId = '',
	} = sessionData || {};

	const { push } = routeActions;

	const props = useMemo(
		() => ({
			push,
			orgId,
			cloudId,
			isAdminHubAIEnabled,
			userId: userId || '',
			getSpaceIdsFromSpaceKeys,
			displayName: displayName || '',
			advancedSearchUrl: ADVANCED_SEARCH.toUrl(),
			peopleDirectoryUrl: PEOPLE_DIRECTORY.toUrl(),
		}),
		[push, orgId, userId, cloudId, displayName, isAdminHubAIEnabled, getSpaceIdsFromSpaceKeys],
	);

	return (
		<CustomSearchExtensionPropsContext.Provider value={props}>
			{children}
		</CustomSearchExtensionPropsContext.Provider>
	);
};
